import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { PRODUCT_FEATURE, StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { CustomProductActions } from './actions';
import { ProductState, StateWithProduct } from './product-state';
import { ProductSelectors } from './selectors';

@Injectable({ providedIn: 'root' })
export class ProductPersistenceService implements OnDestroy {
  protected subscription = new Subscription();

  constructor(
    private statePersistenceService: StatePersistenceService,
    private store: Store<StateWithProduct>,
  ) {}

  sync(): void {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: PRODUCT_FEATURE,
        state$: this.getState(),
        storageType: StorageSyncType.LOCAL_STORAGE,
        onRead: (state) => this.onRead(state),
      }),
    );
  }

  onRead(state: ProductState): void {
    if (state) {
      if (state.selectedPrice) {
        Object.entries(state.selectedPrice.entities).forEach(([productCode, selectedPrice]) => {
          this.store.dispatch(new CustomProductActions.SelectPrice(productCode, selectedPrice.value));
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getState(): Observable<ProductState> {
    return this.store.select(ProductSelectors.getCustomProductState);
  }
}
